import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';

const { Content } = Layout;

export const ContentCustom = ({ children, style }) => (
  <Content
    style={{
      padding: 16,
      background: 'var(--componentBackground)',
      minHeight: 'fit-content',
      ...style
    }}
  >
    {children}
  </Content>
);

ContentCustom.propTypes = {
  style: PropTypes.shape({})
};

ContentCustom.defaultProps = {
  style: undefined
};
